<div class="postback-url-paramters-container">
  <div class="url-paramters-header">
    <h4>{{ 'view_translations.postback_url_parameters' | translate }}</h4>
    <div class="tooltip-container">
      <div class="tooltip-inner-container">
        <div
          *ngIf="isUrlValid"
          class="tooltip-button tool-tip tooltip-icon"
          ngbTooltip="{{'postback_api_parameters' | t}}"
          container="body"
          placement="top"
          tooltipClass="my-configurations-tooltip left">
          <nb-icon icon="info" pack="icomoon"></nb-icon>
        </div>
      </div>
    </div>
  </div>
  <div class="url-parameters-container">
    <div
      class="parameter-container global-transition"
      *ngFor="let urlParameter of urlParameters"
      [ngClass]="{'active' : isParamUsed(urlParameter), 'disabled': !isUrlValid }"
      (click)="setParameter(urlParameter)">
      <div class="tooltip-container">
        <div class="tooltip-inner-container">
          <div>
            <div class="single-parameter-wrapper">
              <h4>{{ urlParameter }}</h4>
              <div class="add-icon" *ngIf="isUrlValid">
                <h3>{{ isParamUsed(urlParameter) ? '-' : '+'}}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
